






























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Mixins
import BrandsStore from "@/mixins/brandsStore";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { DataModules } from "@/store/modules/data";

@Component({
  computed: {
    ...mapGetters({
      scopeGetter: "sortableCategories/getMainScope"
    })
  }
})
export default class AdminProductCatalogueView extends Mixins(BrandsStore) {
  // Getters
  public scopeGetter!: string;

  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  // Variables
  public sortableCategoriesModule = "sortableCategories";
  public categoriesModule: string = DataModules.CATALOGUE_CATEGORIES;

  public get i18n() {
    return {
      cta: this.$t("_action.add_new"),
      category: this.isOption
        ? this.$t("_.product_options_category")
        : this.isAttribute
        ? this.$t("_.product_attributes_category")
        : this.$t("_.products_category"),
      product: this.isOption
        ? this.$t("_.product_option")
        : this.isAttribute
        ? this.$t("_.product_attribute")
        : this.$t("_.product")
    };
  }

  public get isOption() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION);
  }
  public get isAttribute() {
    return this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE);
  }

  public openAddProductCategoryModal() {
    this.$store.dispatch(
      `data/${DataModules.CATALOGUE_CATEGORIES}/openAddEditCategoryModal`,
      { productTypes: this.productTypes }
    );
  }

  public async openAddProductModal() {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/openAddProductModal`,
      {
        props: this.$_.pick(this, ["productTypes"])
      }
    );
  }

  public itemsCounter() {
    return this.isOption
      ? "_plurals.product_options"
      : this.isAttribute
      ? "_plurals.product_attributes"
      : "_plurals.products";
  }

  public get productTypes() {
    return this.$route.name === "adminCatalogueOptions"
      ? [ProductTypes.PRODUCT_OPTION]
      : this.$route.name === "adminCatalogueAttributes"
      ? [ProductTypes.PRODUCT_ATTRIBUTE]
      : [ProductTypes.SINGLE_PRODUCT, ProductTypes.PRODUCT_BUNDLE];
  }
}
